import React from 'react';
import { CurrencyPoundIcon } from '@heroicons/react/24/outline';

const CostTracker = ({ sessionCost, totalCost, mode, isRecording, ratePerHour, provider = 'azure' }) => {
  const safeSessionCost = Number.isFinite(sessionCost) ? sessionCost : 0;
  const safeTotalCost = Number.isFinite(totalCost) ? totalCost : 0;
  const rateLabel = ratePerHour ? ratePerHour.toFixed(3) : '0.000';
  const modeLabel = mode === 'batch' ? 'Batch' : 'Realtime';
  const statusLabel = isRecording ? 'Live' : 'Last session';
  const providerLabelMap = {
    azure: 'Azure Speech (cloud)',
    speechmatics: 'Speechmatics (cloud)',
    sherpa: 'Sherpa ONNX (local GPU)',
  };
  const providerLabel = providerLabelMap[provider] || providerLabelMap.azure;

  const rateNoteMap = {
    azure: 'Pricing based on Azure Speech Services (UK South).',
    speechmatics: 'Pricing based on Speechmatics SaaS realtime tier (estimate).',
    sherpa: 'Pricing reflects local Sherpa inference (no per-minute charge).',
  };
  const rateNote = rateNoteMap[provider] || rateNoteMap.azure;

  return (
    <div className="space-y-2">
      <h4 className="font-semibold text-gray-900 flex items-center gap-2">
        <CurrencyPoundIcon className="h-4 w-4" />
        Cost Tracker
      </h4>
      
      <div className="space-y-1 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-600">{statusLabel} session:</span>
          <span className="font-mono font-semibold">
            £{safeSessionCost.toFixed(6)}
          </span>
        </div>
        
        <div className="flex justify-between">
          <span className="text-gray-600">{modeLabel} rate:</span>
          <span className="font-mono text-xs text-gray-500">
            £{rateLabel}/hr
          </span>
        </div>

        <div className="flex justify-between">
          <span className="text-gray-600">Provider:</span>
          <span className="text-xs text-gray-500">{providerLabel}</span>
        </div>
        
        <div className="pt-2 border-t">
          <div className="flex justify-between">
            <span className="text-gray-600">Total Usage:</span>
            <span className="font-mono font-semibold">
              £{safeTotalCost.toFixed(4)}
            </span>
          </div>
        </div>
      </div>

      <div className="text-xs text-gray-500 mt-2">
        <span>{rateNote}</span>
      </div>
    </div>
  );
};

export default CostTracker;
